import { selectBasketIsEmpty, selectBasketList } from 'containers/OrderDetails/basketSlice'
import SimplifiedSummary from 'containers/OrderDetails/Summary/SimplifiedSummary'
import { resetContract, selectContract } from '../../Login/loginSlice'
import InaccessiblePopup from 'components/popups/InaccessiblePopup'
import { useDispatch, useSelector } from 'react-redux'
import { resetForm, updateValues } from '../formSlice'
import useTranslation from 'hooks/useTranslation'
import { useHistory } from 'react-router-dom'
import { useState, useEffect } from 'react'
import Loading from 'components/Loading'
import { STATUS } from 'utils/constants'
import { PATCH } from 'rest/request'
import { user } from 'rest/urls'
import Form from './Form'
import '../style.scss'

const Contract = ({ isDesktop = false }) => {

  const [status, setStatus] = useState(STATUS.idle)
  const [error, setError] = useState('')

  const list = useSelector(selectBasketList)
  const contract = useSelector(selectContract)
  const isBasketEmpty = useSelector(selectBasketIsEmpty)

  const dispatch = useDispatch()
  const { replace } = useHistory()
  const { t } = useTranslation('form')

  useEffect(() => {
    const savedFields = typeof contract === 'object' && Object
      .entries(contract)
      .reduce((r, [k, v]) => {
        if (!v) {
          const key = k === 'apartment_nr' ? 'localNumber'
            : k === 'identity_card_type' ? 'cardType'
              : k === 'identity_card' ? 'identityCard'
                : k === 'building_nr' ? 'houseNumber'
                  : k === 'zip_code' ? 'postalCode' : k
          r = { ...r, [key]: v }
        }
        return r
      }, {})

    if (Object.keys(savedFields) > 0) {
      dispatch(updateValues(savedFields))
    }
  }, [dispatch, contract])

  const submit = async body => {
    setStatus(STATUS.pending)

    try {
      await PATCH(user, { body, credentials: true })
      setStatus(STATUS.succeed)
      dispatch(resetForm())
      dispatch(resetContract())
      replace(list?.length > 0 ? '/order/billing' : '/')

    } catch (err) {
      setStatus(STATUS.failed)
      console.error(`Error: ${err}`)
    }
  }


  return (
    <>
      <div className='contract'>
        <div className='contract__title title'>
          <div>{t('userDetails')}</div>
          <div>{t('fillInMissingDetails')}</div>
        </div>

        {error && <InaccessiblePopup
          desc={error}
          close={() => setError('')}
        />}

        <div className='contract__main main center'>
          {status === STATUS.pending && <Loading middleOfPage />}

          <Form
            block={status === STATUS.pending}
            submit={submit} />
        </div>
      </div>

      {isDesktop && !isBasketEmpty && <div className='orderInfo__aside'>
        <SimplifiedSummary />
      </div>}
    </>
  )
}

export default Contract